import type { InspirationItem } from "@/types";

export const inspirations: InspirationItem[] = [
  {
    id: "det-01",
    label: "Detalhes de tecido",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20editorial%20detail%20of%20soft%20draped%20fabric%20in%20warm%20plum%20and%20cream%20tones%2C%20delicate%20texture%2C%20natural%20daylight%2C%20elegant%20minimal%20composition%2C%20realistic%20material%2C%20no%20text%2C%20no%20logos&width=700&height=950&seq=amora-insp-det-01&orientation=portrait",
  },
  {
    id: "mix-02",
    label: "Combinações de roupas",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20editorial%20of%20a%20feminine%20outfit%20combination%20with%20a%20blouse%20and%20trousers%20in%20warm%20neutral%20tones%2C%20styled%20on%20a%20beige%20surface%2C%20soft%20natural%20light%2C%20no%20text%2C%20no%20logos&width=700&height=700&seq=amora-insp-mix-02&orientation=squarish",
  },
  {
    id: "ace-03",
    label: "Acessórios discretos",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20delicate%20feminine%20accessories%20with%20matte%20gold%20details%20and%20a%20small%20leather%20bag%20on%20a%20warm%20beige%20surface%2C%20soft%20light%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20no%20logos&width=700&height=700&seq=amora-insp-ace-03&orientation=squarish",
  },
  {
    id: "look-04",
    label: "Looks completos",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20Brazilian%20woman%20wearing%20a%20complete%20feminine%20look%20in%20warm%20neutral%20tones%2C%20standing%20on%20an%20elegant%20urban%20street%2C%20natural%20daylight%2C%20realistic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=950&seq=amora-insp-look-04&orientation=portrait",
  },
  {
    id: "back-05",
    label: "Bastidores",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20behind%20the%20scenes%20of%20a%20fashion%20shoot%20with%20warm%20neutral%20studio%20setup%20and%20soft%20lighting%2C%20no%20text%2C%20no%20logos%2C%20natural%20documentary%20style&width=700&height=700&seq=amora-insp-back-05&orientation=squarish",
  },
  {
    id: "arara-06",
    label: "Araras organizadas",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20clothing%20rack%20with%20well%20organized%20feminine%20garments%20in%20warm%20neutral%20and%20plum%20tones%2C%20soft%20natural%20light%20in%20a%20minimal%20warm%20interior%2C%20no%20text%2C%20no%20logos&width=700&height=700&seq=amora-insp-arara-06&orientation=squarish",
  },
  {
    id: "cot-07",
    label: "Momentos cotidianos",
    tall: true,
    image:
      "https://readdy.ai/api/search-image?query=Candid%20lifestyle%20photo%20of%20a%20Brazilian%20woman%20in%20a%20feminine%20outfit%20walking%20in%20a%20sunlit%20urban%20neighborhood%2C%20warm%20neutral%20tones%2C%20natural%20daylight%2C%20realistic%20skin%20texture%2C%20full%20body%2C%20no%20text%2C%20no%20logos&width=700&height=950&seq=amora-insp-cot-07&orientation=portrait",
  },
  {
    id: "cafe-08",
    label: "Café e conversa",
    tall: false,
    image:
      "https://readdy.ai/api/search-image?query=Lifestyle%20editorial%20photo%20of%20a%20Brazilian%20woman%20in%20an%20elegant%20outfit%20sitting%20in%20a%20cozy%20cafe%20with%20warm%20ambient%20light%20and%20neutral%20beige%20interiors%2C%20realistic%20skin%20texture%2C%20no%20text%2C%20no%20logos&width=700&height=700&seq=amora-insp-cafe-08&orientation=squarish",
  },
];